import { createAction } from '@reduxjs/toolkit'
import { ChartDayData } from 'types'
import { ArenaData } from './reducer'

export const updateData = createAction<{ data: ArenaData }>('arena/updateArenaData')
